<template lang="html">
  <div class="cw-dropdown main">
    <div class="dropdown" :class="[{ 'is-active': isActive }, ...classes]">
      <div
        class="dropdown-trigger"
        aria-controls="dropdown-menu"
        v-on:click.stop="toggleIsActive"
        aria-haspopup="true"
      >
        <slot name="trigger"> </slot>
      </div>
      <div class="dropdown-menu is-floating" role="menu">
        <div class="dropdown-content">
          <slot> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-dropdown',
  // share common functionality with component mixins
  mixins: [],
  props: {
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {
    toggleIsActive() {
      this.$emit('update:isActive', !this.isActive);
    },
  },
};
</script>

<style lang="stylus">
.dropdown-menu {
  left: unset
  min-width: 10rem
}
.dropdown-content {
  overflow: hidden
}
.dropdown.is-black .dropdown-content {
  background-color: #000
  * {
    color: #fff
  }

  a.dropdown-item {

    display: flex
    align-items: center
    @media (max-width: 800px){
      font-size: 1.25rem
      padding-top: 0.75rem
      padding-bottom: 0.75rem
    }
    & > *:not(:first-child){
      margin-left: 0.5rem
    }
    &:hover{
      background-color: #222222
    }
  }
  .dropdown-divider {
    border-top: 1px solid #777;
  }


}

hr.dropdown-divider {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #555;
  margin: 0.2rem 0;
  padding: 0;
}

.header-dropdown .dropdown-menu {
  top: 4rem;
}

.anchored-bottom .dropdown-menu {
  top: unset
  bottom: 0
}

.selection-dropdown {
  .dropdown-item {
    cursor: pointer;
    &:hover {
      background: lighten(#4B494B, 65);
    }
  }
}
</style>
